import { useMemo } from 'react';

import { useAppSelector } from 'app/hooks';
import { useSnapshot } from 'features/snapshots/api/getSnapshot';
import { selectMarkersBySnapshotId } from 'features/markers/markersSlice';

const useMarkers = (snapshotId: number) => {
  const selectCurrentMarkers = useMemo(selectMarkersBySnapshotId, []);

  const { data: snapshot } = useSnapshot({ snapshotId });
  const unsavedMarkers = useAppSelector((state) =>
    selectCurrentMarkers(state, snapshotId)
  );

  const { markers } = snapshot || {};

  const combinedMarkers = useMemo(() => {
    const unsavedMarkerIndexes = unsavedMarkers.map((marker) => marker.index);
    const unMovedMarkers =
      markers?.filter(
        (marker) => !unsavedMarkerIndexes.includes(marker.index)
      ) || [];
    return [...unMovedMarkers, ...unsavedMarkers];
  }, [markers, unsavedMarkers]);

  return combinedMarkers;
};

export default useMarkers;
